module.exports = __webpack_public_path__ + "static/media/eucerin.6f5ed030.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/customers/eucerin.jpg
// module id = 128
// module chunks = 0